import React from 'react';
import {
  FieldProps,
  ErrorMessage,
} from 'formik';

import {
  Checkbox,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

type CheckboxProps = {
  align?: string;
  justify?: string;
  label?: string;
  placeholder?: string;
} & FieldProps;

const CheckboxField = ({
  align,
  justify,
  label,
  field,
  form: { touched, errors },
  placeholder,
  ...props
}: CheckboxProps) => {
  const iserror = (touched[field.name] && errors[field.name]);

  return (
    <Flex
      column
      width="100%"
      spacing={5}
    >
      <Flex
        width="100%"
        spacing={5}
        align={align}
        justify={justify}
      >
        <Checkbox
          {...field}
          {...props}
          id={`${field.name}-id`}
          checked={field.value}
          placeholder={placeholder}
        />
        {label && (
          <S.Label
            htmlFor={`${field.name}-id`}
          >
            {label}
          </S.Label>
        )}
      </Flex>
      <Flex flex="0 1 100%;">
        <ErrorMessage
          name={field.name}
          component={S.Error}
        />
      </Flex>
    </Flex>
  );
};

CheckboxField.defaultProps = {
  align: 'center',
  justify: 'flex-start',
  label: '',
  placeholder: '',
};

export default CheckboxField;
